
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CommunicationLogEntryModel } from './Communication.Api.Models.CommunicationLogEntry';
import { NotificationStatus } from 'enums/NotificationStatus';
import { Model, ModelProperty } from 'models/Model';


export class NotificationModel extends Model<NotificationModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'guid', languageString: 'notification.property.id', isHidden: true },
		{ name: 'created', type: 'Date', languageString: 'notification.property.created', isHidden: true },
		{ name: 'createdById', type: 'guid', languageString: 'notification.property.createdById' },
		{ name: 'assignedToUserId', type: 'guid', languageString: 'notification.property.assignedToUserId' },
		{ name: 'companyId', type: 'guid', languageString: 'notification.property.companyId' },
		{ name: 'communicationLogEntryId', type: 'guid', languageString: 'notification.property.communicationLogEntryId' },
		{ name: 'communicationLogEntry', type: 'CommunicationLogEntryModel', languageString: 'notification.property.communicationLogEntry', isHidden: true, isObject: true, new: () => { return new CommunicationLogEntryModel }, properties: () => { return CommunicationLogEntryModel.classProperties } },
		{ name: 'status', type: 'NotificationStatus', languageString: 'notification.property.status' }
	];
	[key: string]: any;
	
	public id?: string;
	public created?: Date;
	public createdById?: string;
	public assignedToUserId?: string;
	public companyId?: string;
	public communicationLogEntryId?: string;
	public communicationLogEntry?: CommunicationLogEntryModel;
	public status: NotificationStatus;
    
	constructor(){
		super();
		this.id = undefined;
		this.created = undefined;
		this.createdById = undefined;
		this.assignedToUserId = undefined;
		this.companyId = undefined;
		this.communicationLogEntryId = undefined;
		this.communicationLogEntry = undefined;
		this.status = 0;
		
	}
	getProperties(){
		return NotificationModel.classProperties;
	}
}

